(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customization-scratch-card"] && !Shopify.designMode) return;
  try {
    (function() {
  const heading = document.querySelector('.scratch-card-text__heading');

  function adjustFontSizeHeading() {
    if (!heading) return;

    const maxFontSize = 23;
    const minFontSize = 7;
    let fontSize = maxFontSize;

    heading.style.fontSize = fontSize + 'px';

    while (fontSize > minFontSize && heading.scrollHeight > heading.clientHeight) {
      fontSize -= 1;
      heading.style.fontSize = fontSize + 'px';
    }
  }

  window.addEventListener('resize', adjustFontSizeHeading, true);
  document.addEventListener('DOMContentLoaded', adjustFontSizeHeading);
})();
  } catch(e) { console.error(e); }
})();

})();
